'use strict';

import Actions from './actions';
import Alert from '../../../../components/alert.jsx';
import Button from '../../../../components/form/button.jsx';
import ControlGroup from '../../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../../components/form/text-control.jsx';
import TextareaControl from '../../../../components/form/textarea-control.jsx';
import UserTermsOfService from '../../checkout/user-terms-of-service.jsx';
import SigninOrRegisterFlow from '../../../login/signin-or-register/signin-or-register-flow';
import btHostedFields from 'braintree-web/hosted-fields';
import { TOS_ID } from '../../../../global-constants';
import CheckoutActions from '../../checkout/actions.js';
import LinkState from '../../../../helpers/link-state.js';
import { Steps } from './reducers/create-new.js';
import Constants from '../../checkout/constants.js';
import AccountActions from '../../../account/actions.js';
import Moment from 'moment';



class Form extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
        this.els = {};
        this.state = Store.getState();
    }

    componentDidMount() {

        CheckoutActions.getMyAccount(Store, (err, response) => {

            if (!err) {
                CheckoutActions.getBtToken(Store);
                CheckoutActions.getTosDetails(TOS_ID, Store, (err, tos) => {
                    CheckoutActions.getTosAgreedResults({ id: tos.id, versionGte: tos.version, limit: 0 }, Store);
                });
            }
        });
        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.name) {
            this.input.name.focus();
        }
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    componentDidUpdate(prevProps, prevState, snapshot){

        if ( this.state.createNew.step !== Steps.PAYMENT_DETAILS) {
            return;
        }

        ///if (!prevState.braintreeClient.client && this.state.braintreeClient.client ) {
        if ( (prevState.createNew.step === Steps.ORGANIZATION_DETAILS &&
            this.state.createNew.step === Steps.PAYMENT_DETAILS  )
            ||
            (!prevState.braintreeClient.client && this.state.braintreeClient.client ) ) {
            CheckoutActions.createHostedFields(Store);
            btHostedFields.create(
                {
                    client: this.state.braintreeClient.client,
                    styles: {
                        'input': {
                            'font-size': '16px'
                        },
                        'input.invalid': {
                            'color': 'red'
                        },
                        /*
                        'input.valid': {
                            'color': '#5CB863'
                        },*/
                        '::-webkit-input-placeholder': {
                            'color': '#999'
                        },
                        ':-moz-placeholder': {
                            'color': '#999'
                        },
                        '::-moz-placeholder': {
                            'color': '#999'
                        },
                        ':-ms-input-placeholder': {
                            'color': '#999'
                        }

                    },
                    fields: {
                        number: {
                            selector: '#number',
                            placeholder: 'Debit/Credit Card Number'
                        },
                        cvv: {
                            selector: '#cvv',
                            placeholder: 'Security Code'
                        },
                        expirationDate: {
                            selector: '#expiration-date',
                            placeholder: 'mm/yy'
                        },
                        postalCode: {
                            selector: '#postal-code',
                            placeholder: '90222'
                        }
                    }
                },
                (err, hostedFieldsInstance) => {
                    CheckoutActions.createHostedFieldsResponse(err, hostedFieldsInstance, Store);
                    if ( err ) {
                        console.log(err);
                        return;
                    }
                }
            );
        }

        if (!prevState.hostedFields.hostedFieldsInstance && this.state.hostedFields.hostedFieldsInstance ) {
            this.state.hostedFields.hostedFieldsInstance.on('validityChange', this.validityChange.bind(this));
            this.state.hostedFields.hostedFieldsInstance.on('cardTypeChange', this.cardTypeChange.bind(this));
        }

    }

    signinSuccess() {
        document.location.reload();
        //Actions.getMyAccount(Store);
    }

    signinCancel() {
        //console.log('complete');
        document.location = '/organizations';
    }

    acceptTos() {
        CheckoutActions.acceptTos(TOS_ID, Store, (err) => {
            if ( !err ) {
                CheckoutActions.getTosAgreedResults({ id: this.state.tos.id, versionGte: this.state.tos.version, limit: 0 }, Store);
            }
        });
    }

    declineTos() {
        location = '/organizations';
    }

    signout() {
        Actions.signout((err) => {
            if ( !err ) {
                location.reload();
            }
        });
    }

    gotoOrganizationDetails(event) {

        event.preventDefault();
        event.stopPropagation();

        Store.dispatch({
            type: Constants.GOTO_ORGANIZATION_DETAILS
        });
    }

    gotoPaymentDetails(event) {

        event.preventDefault();
        event.stopPropagation();
        Store.dispatch({
            data: {
                name: this.state.createNew.name,
                address1: this.state.createNew.address1,
                address2: this.state.createNew.address2,
                city: this.state.createNew.city,
                state: this.state.createNew.state,
                country: this.state.createNew.country,
                zip: this.state.createNew.zip,
                phone: this.state.createNew.phone
            },
            type: Constants.GOTO_PAYMENT_DETAILS
        });
    }

    //todo clean things up like the hostedInstance in the redux store!
    submit(event) {
        event.preventDefault();
        if ( !this.state.hostedFields.hostedFieldsInstance ) {
            return;
        }

        CheckoutActions.submitLocalFields(Store);
        if ( this.els.cardholderName.value === ''){

            CheckoutActions.submitLocalFieldsResponse({
                code: 'LOCAL_FIELDS_FIELDS_INVALID',
                invalidFieldKeys: { 'cardholderName': { message: 'Required' } }
            }, Store);
            return;
        }

        /*
        if ( this.els.cardholderName.value.toLowerCase().indexOf('test') < 0){

            Actions.submitLocalFieldsResponse({
                code: 'LOCAL_FIELDS_FIELDS_INVALID',
                invalidFieldKeys: { 'cardholderName': { message: 'Invalid Test Name' } }
            } );
            return;
        }*/


        CheckoutActions.submitHostedFields(Store);

        this.state.hostedFields.hostedFieldsInstance.tokenize( {
            cardholderName: this.els.cardholderName.value
        }, (tokenizeErr, payload) => {
            CheckoutActions.submitHostedFieldsResponse(tokenizeErr, Store);
            if (tokenizeErr) {
                CheckoutActions.submitHostedFieldsResponse(tokenizeErr, Store);
                //console.error(tokenizeErr);
                return;
            }

            CheckoutActions.postTokenAndOrganization( {
                //cart_id: this.state.cartContents.cart_id,
                nonce: payload.nonce,
                name: this.state.createNew.name,
                address1: this.state.createNew.address1,
                address2: this.state.createNew.address2,
                city: this.state.createNew.city,
                state: this.state.createNew.state,
                country: this.state.createNew.country,
                zip: this.state.createNew.zip,
                phone: this.state.createNew.phone
            }, Store, (err, response) => {
                if ( !err ) {
                    AccountActions.switchAccount('oadmin', response.oadmin_id,
                        response.organization_id, undefined, `/organizations/buynow/${response.order.id}`);
                }
            });

        });

    }

    validityChange(event){

        Store.dispatch({
            type: Constants.VALIDITY_CHANGE,
            event
        });
    }

    cardTypeChange(event){
        // Handle a field's change, such as a change in validity or credit card type
        const message = {
            type: Constants.CARD_CHANGE,
            cardNiceType: '',
            cardType: ''
        };
        if (event.cards.length === 1) {
            message.cardNiceType = event.cards[0].niceType;
            message.cardType = event.cards[0].type;
        }

        Store.dispatch( message );

    }

    cardholderNameChange(event){

        const isValid = this.els.cardholderName.value.length >= 0;
        Store.dispatch({
            type: Constants.VALIDITY_CHANGE,
            event: {
                emittedBy: 'cardholderName',
                fields: {
                    cardholderName: {
                        container: {
                            id: 'cardholderName'
                        },
                        isValid
                    }
                }


            }
        });
    }

    /*
    switchAcounts() {
        const bto = this.state.postTokenAndOrganization;
        AccountActions.switchAccount('oadmin', bto.oadmin_id, bto.organization_id);
    }*/

    render() {

        let signin;
        let tosAgree;
        const state = this.state;
        if (!state.my.hydrated || state.my.loading || state.tosAgreed.loading || state.tos.loading ) {
            signin = (
                <div><i className="fa fa-spin fa-spinner"></i></div>
            );
        }
        else if ( !this.state.my.account.User.id ){
            signin = <SigninOrRegisterFlow
                accountOnly={true}
                autoLoginAfterRegister={true}
                title="Create Account or Sign In"
                subTitle="To creating your organization you must create an account or sign in with an existing one."
                show={true} signinComplete={this.signinSuccess.bind(this)} cancel={this.signinCancel.bind(this)} my={this.state.my} />;
        }
        else if ( state.tosAgreed.items.total === 0){
            tosAgree = (
                <UserTermsOfService {...this.state.createNewTosAgreed} accept={this.acceptTos.bind(this)} decline={this.declineTos.bind(this)} title={state.tos.title} sub_title={state.tos.sub_title} terms={state.tos.terms} show={true}/>
            );
        }

        /*
        const alerts = [];
        let alert = [];

        if (this.state.success) {
            alert = (
                <h4 style={{ marginTop: '25px' }} className="text-success">Thank You!  We'll get back to you ASAP!</h4>
            );
        }
        else if (this.state.error) {
            alert = <Alert
                type="danger"
                message='There was a problem.'
            />;
        }*/


        let form;

        const bto = this.state.postTokenAndOrganization;
        if (!bto.success) {
            if ( this.state.createNew.step === Steps.ORGANIZATION_DETAILS ) {

                let alert = '';
                if ( this.state.createNew.error) {
                    alert = <Alert
                        type="danger"
                        message={this.state.createNew.error}
                    />;
                }

                form = (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-sm-12">
                                <h4 className="orange">Simplify</h4>
                                <p>
                                The PrioraCare Provider Package enables your organization to allocate trainings and track progress all in one place.  Videos, handouts, tests,
                                and progress are all at your finger tips.
                                </p>
                                <h6><strong>Cost</strong></h6>
                                <p>$99/year includes organizational features.  Trainings are billed separately.</p>
                                <p>$1/active user/month</p>
                                <p>Upload all of your users at once.  You are only charged for the ones you use.</p>
                            </div>
                        </div>
                        <form onSubmit={this.gotoPaymentDetails.bind(this)}>
                            <h4 className='orange'>Organization Details</h4>
                            <div className="row">
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        ref={(c) => (this.input.name = c)}
                                        name="createNew.name"
                                        label="Organization Name (required)"
                                        value={this.state.createNew.name}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.name}
                                        help={this.state.createNew.help.name}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        value={this.state.my.account.User.email}
                                        groupClasses={{ 'no-margin': true }}
                                        name="email"
                                        label="Administrator Email"
                                        hasError={false}
                                        disabled={true}
                                    />
                                    <button type='button' style={{ padding: '0px' }} onClick={this.signout.bind(this)} className="btn-link small form-group text-left">Email incorrect?  Sign out and register or sign in with another.</button>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.address1"
                                        label="Address 1"
                                        autoComplete='address-line1'
                                        ref={(c) => (this.input.address1 = c)}
                                        value={this.state.createNew.address1}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.address1}
                                        help={this.state.createNew.help.address1}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.address2"
                                        label="Address 2"
                                        autoComplete='address-line2'
                                        ref={(c) => (this.input.address2 = c)}
                                        value={this.state.createNew.address2}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.address2}
                                        help={this.state.createNew.help.address2}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.city"
                                        label="City"
                                        ref={(c) => (this.input.city = c)}
                                        value={this.state.createNew.city}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.city}
                                        help={this.state.createNew.help.city}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.state"
                                        label="State"
                                        ref={(c) => (this.input.state = c)}
                                        value={this.state.createNew.state}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.state}
                                        help={this.state.createNew.help.state}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.country"
                                        label="Country"
                                        autoComplete='country'
                                        ref={(c) => (this.input.country = c)}
                                        value={this.state.createNew.country}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.country}
                                        help={this.state.createNew.help.country}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.zip"
                                        label="Zip"
                                        autoComplete='postal-code'
                                        ref={(c) => (this.input.zip = c)}
                                        value={this.state.createNew.zip}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.zip}
                                        help={this.state.createNew.help.zip}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TextControl
                                        name="createNew.phone"
                                        label="Phone"
                                        autoComplete='tel'
                                        ref={(c) => (this.input.phone = c)}
                                        value={this.state.createNew.phone}
                                        onChange={LinkState.bind(this)}
                                        hasError={this.state.createNew.hasError.phone}
                                        help={this.state.createNew.help.phone}
                                        disabled={this.state.createNew.loading}
                                    />
                                </div>
                                <div className="col-xs-12">
                                    {alert}
                                </div>
                                <div className="col-xs-12">
                                    <ControlGroup hideLabel={true} hideHelp={true}>
                                        <Button
                                            type="submit"
                                            inputClasses={{ 'btn-primary': true }}
                                            disabled={this.state.loading}>
                                    Next
                                            <Spinner space="left" show={this.state.loading} />
                                        </Button> (Step 1 of 2)
                                    </ControlGroup>
                                </div>
                            </div>
                        </form>
                    </React.Fragment>
                );
            }
            else {

                const alerts = [];

                if ( this.state.braintreeToken.error ) {
                    alerts.push(<Alert
                        key="danger"
                        type="danger"
                        message={this.state.braintreeToken.errorMessage}
                    />);
                }

                if ( this.state.hostedFields.error ) {
                    alerts.push(<Alert
                        key="danger"
                        type="danger"
                        message={this.state.hostedFields.errorMessage}
                    />);
                }

                if ( this.state.localFields.error ) {
                    alerts.push(<Alert
                        key="danger"
                        type="danger"
                        message={this.state.localFields.errorMessage}
                    />);
                }

                if ( this.state.postTokenAndOrganization.hydrated && !this.state.postTokenAndOrganization.success) {
                    alerts.push(<Alert
                        key="danger"
                        type="danger"
                        message={this.state.postTokenAndOrganization.message}
                    />);
                }

                if ( this.state.postTokenAndOrganization.success === true) {
                    alerts.push(<Alert
                        key="success"
                        type="success"
                        message={this.state.postTokenAndOrganization.message}
                    />);
                }


                const ifk = this.state.hostedFields.invalidFieldKeys;

                let submitDisabled = 'disabled';
                if (this.state.tosAgreed.hydrated && this.state.hostedFields.hydrated &&
                    !this.state.postTokenAndOrganization.loading && !this.state.postTokenAndOrganization.success ){
                    submitDisabled = '';
                }

                let card;
                if ( this.state.postTokenAndOrganization.loading ){
                    card = (<i className="fa fa-spinner fa-spin" ></i>);
                }
                else if ( this.state.hostedFields.cardNiceType ) {
                    card =  'Pay with ' + this.state.hostedFields.cardNiceType;
                }
                else {
                    card = 'Pay with Card';
                }


                form = (
                    <React.Fragment>
                        <div className="panel panel-default" style={{ position: 'relative' }}>
                            <div className="panel-heading">
                                <h3 className="panel-title">Purchase Details</h3>
                            </div>
                            <div className="panel-body">
                                <div className={'row'} >
                                    <div className={'col-sm-6 col-xs-12'}>
                                        <div>
                                            Organization
                                        </div>
                                        <div>
                                            <h4 className='contact-info'>{this.state.createNew.name}</h4>
                                        </div>
                                        <div>
                                            <h4>{this.state.createNew.address1}</h4>
                                        </div>
                                        <div>
                                            <h4>{this.state.createNew.address2}</h4>
                                        </div>
                                        <div>
                                            <h4>{this.state.createNew.city} {this.state.createNew.state}</h4>
                                        </div>
                                        <div>
                                            <h4>{this.state.createNew.country} {this.state.createNew.zip}</h4>
                                        </div>
                                        <div>
                                            <h4>{this.state.createNew.phone}</h4>
                                        </div>

                                        <Button
                                            onClick={this.gotoOrganizationDetails.bind(this)}
                                            type="submit"
                                            inputClasses={{ 'btn-link': true, 'no-padding': true }}
                                            disabled={false}>
                                        Modify
                                        </Button>
                                    </div>
                                    <div className={'col-sm-6 col-xs-12'}>
                                        <div>
                                            Subscription
                                        </div>
                                        <h4>Provider Subscription $99/year.</h4>
                                        <h4>Active Account Subscription $1/month/account.</h4>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='cc_form'>
                            <div className={submitDisabled ? 'cc_mask' : ''}></div>
                            <form ref={ (c) => {
                                this.els.form = c;
                            }} className="" id="ccform" onSubmit={this.submit.bind(this)}>
                                {
                                    submitDisabled && (
                                        <div className="text-center cc-spin">
                                            <i className="fa fa-spinner fa-spin fa-4x cc-spin" ></i></div>
                                    )
                                }
                                <div className="panel panel-default" style={{ position: 'relative' }}>
                                    <div className="panel-heading">
                                        <h3 className="panel-title">Card Details</h3>
                                    </div>
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="form-group col-sm-12">
                                                <label className="control-label">Card Number</label>
                                                <div className={`form-control ${ifk.number ? 'alert-anger' : ''}`} id="number"></div>
                                                <span className="helper-text">{ ifk.number ? ifk.number.message : '' }</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-sm-6">
                                                <label className="control-label">Security Code</label>
                                                <div className={`form-control ${ifk.cvv ? 'alert-anger' : ''}`}  id="cvv"></div>
                                                <span className="helper-text">{ ifk.cvv ? ifk.cvv.message : '' }</span>
                                            </div>
                                            <div className="form-group col-sm-6">
                                                <div className="row">
                                                    <label className="control-label col-xs-12">Expiration Date</label>
                                                    <div className="col-xs-12">
                                                        <div className={`form-control ${ifk['expiration-date'] ? 'alert-anger' : ''}`}  id="expiration-date"></div>
                                                        <span className="helper-text">{ ifk['expiration-date'] ? ifk['expiration-date'].message : '' }</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="form-group col-sm-6">
                                                <label className="control-label">Name on Card</label>
                                                <input onChange={this.cardholderNameChange.bind(this)} ref={(c) => {
                                                    this.els.cardholderName = c;
                                                }} placeholder="Name on card" className={`form-control ${ifk.cardholderName ? 'alert-danger' : ''}`}  id="cardholderName"></input>
                                                <span className="helper-text"></span>
                                            </div>
                                            <div className="form-group col-sm-6">
                                                <label className="control-label">Zipcode</label>
                                                <div className={`form-control ${ifk.postalCode ? 'alert-anger' : ''}`}  id="postal-code"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {alerts}
                                <div className="row">
                                    <div className="col-sm-12">
                                        <button  ref={ (c) => {
                                            this.els.submit = c;
                                        }} value="submit" id="submit" className="btn btn-success btn-lg btn-block" disabled={submitDisabled}>{card}</button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </React.Fragment>

                );
            }

        }

        return (
            <section>
                <h3 className="orange page-header">Provider Sign Up</h3>
                {signin}
                {tosAgree}
                {form}
            </section>
        );
    }
}


export default Form;
